import {
  accountApi,
  addressVerifyApi,
  applicationApi,
  benefitsApi,
  emailVerifyApi,
  invitationApi,
  levelsApi,
  phoneVerifyApi,
  referralVerifyApi,
  supportFormApi,
  userApi,
  verificationsApi,
} from './endpoints';

export const {
  useUpdateAccountMutation,
  useInvitationMutation,
  useDestroyTeamMemberMutation,
  useDestroyInvitationMutation,
  useDestroyAccountMutation,
  useStorageSASMutation,
  useTransferAdminMutation,
} = accountApi;
export const { useAddressVerifyMutation } = addressVerifyApi;
export const {
  useCreateApplicationMutation,
  useDestroyApplicationMutation,
  useValidateApplicationAddressMutation,
  useValidateApplicationAffiliationsMutation,
  useValidateApplicationIntroductionMutation,
  useValidateApplicationStartupDetailsMutation,
} = applicationApi;
export const {
  useActivateUrlBenefitMutation,
  useActivateAzureBenefitMutation,
  useActivateATABenefitMutation,
  useActivateVisualStudioBenefitMutation,
  useDestroyVisualStudioBenefitMutation,
} = benefitsApi;
export const { useEmailVerifyMutation, useEmailTokenValidationMutation } = emailVerifyApi;
export const { usePhoneVerifyMutation, usePhoneTokenValidationMutation } = phoneVerifyApi;
export const { useVerifyReferralMutation, useReverifyReferralMutation } = referralVerifyApi;
export const { useUpgradeLevelMutation } = levelsApi;
export const {
  useUpdateUserMutation,
  useUserStorageSASMutation,
  useLogoutMutation,
  useAcceptAgreementMutation,
  useDeleteUserMutation,
} = userApi;
export const { useAcceptInvitationMutation, useResendInvitationMutation } = invitationApi;
export const { useRequestBvMutation, useBvAppealMutation, useRequestDvMutation, useDvAppealMutation } =
  verificationsApi;
export const { useCreateUserSupportCaseMutation } = supportFormApi;
